import PropTypes from 'prop-types'

export default PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  code: PropTypes.string.isRequired,
  item_description: PropTypes.string.isRequired,
  hierarchy: PropTypes.string.isRequired
})
